import { yupResolver } from "@hookform/resolvers/yup";
import CloseIcon from "@mui/icons-material/Close";
import {
  Alert,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  Modal,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { createCategoryAction } from "../../../redux/coupon/CreateCategoryRTK";
import axios from "../../../config/authaxios";

// schema
const createCategorySchema = yup
  .object({
    categoryname: yup.string().required("please fill the name"),
    cashback_percentage: yup
      .number()
      .required("please fill the %")
      .typeError("Please fill the percentage"),
    position: yup.number().when("popular_category", {
      is: true,
      then: yup
        .number()
        .transform((value, originalValue) => (originalValue === "" ? null : value))
        .nullable()
        .notRequired(),
      otherwise: yup
        .number()
        .required("please fill the position")
        .typeError("Please fill the position"),
    }),
    // image: yup
    //   .string()
    //   .required("please fil the position")
    //   .typeError("please select image"),
  })
  .required();

// style
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  background: "#fff",
  boxShadow: 24,
  padding: 20,
};

export default function CreateCategory({ createCategory, setCreateCategory }) {
  // state----->
  const {
    register,
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({ resolver: yupResolver(createCategorySchema), defaultValues: { popular_category: false } });
  const isPopularCategory = watch("popular_category");
  const dispatchRTK = useDispatch();
  const createCategorySelector = useSelector((state) => state.createCategory);
  const { status, message } = createCategorySelector;
  const [snackbarState, setSnackbarState] = useState(false);
  const [imageUploaded,setImageUploaded]=useState(null)

  // function -->
  const handleClose = () => {
    setCreateCategory(false);
  };

  const createCategoryFunc = (data) => {
    console.log("data->",data)
    dispatchRTK(createCategoryAction({ ...data, name: data?.categoryname, image: imageUploaded, popular_category: !!data?.popular_category }));
    setSnackbarState(true);
  };

  const snackBarClose = () => {
    setSnackbarState(false);
    setCreateCategory(false);
  };

  const handlefileInput = (e) => {
    const Dataform = new FormData();
    Dataform.append("file", e.target.files[0]);
    let FileSize = Number(e.target.files[0].size / 1000);
    var file = e.target.files[0];
    var _URL = window.URL || window.webkitURL;
    let img = new Image();
    var width, height;
    img.onload = function () {
    // //console.log(img, file);
    width = this.width;
    height = this.height;
    
    axios.post(`/admin/upload-image`, Dataform).then((res) => {
    //console.log(">>Image_url>>", res.data.Image.url);
    
    // setCoupons({ ...coupons, image: res.data.Image.url });
    setImageUploaded(res.data.Image.url)
    // setEditPropsData({ ...editPropsData, 'image': res.data.Image.url })
    // setImage(res.data.Image.url);
    //console.log("coupons-->",coupons)
    });
    alert(`Image is Successfully Uploaded, Your file size is ${FileSize}`);
    
    };
    img.onerror = function () {
    alert("not a valid file: " + file.type);
    };
    img.src = _URL.createObjectURL(file);
    };

  return (
    <>
      <Modal open={createCategory} onClose={handleClose}>
        <Box style={style}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Create Category
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Stack>
          <form onSubmit={handleSubmit(createCategoryFunc)}>
            <Stack spacing={2}>
              <TextField
                label="Category Name"
                variant="outlined"
                fullWidth
                {...register("categoryname")}
                error={errors?.categoryname?.message}
                helperText={errors?.categoryname?.message}
              />
              <TextField
                type="number"
                label="Cashback Percentage"
                variant="outlined"
                fullWidth
                {...register("cashback_percentage")}
                error={errors?.cashback_percentage?.message}
                helperText={errors?.cashback_percentage?.message}
              />
              <Controller
                name="popular_category"
                control={control}
                defaultValue={false}
                render={({ field }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!field.value}
                        onChange={(e) => field.onChange(e.target.checked)}
                      />
                    }
                    label="Mark as Popular Category"
                  />
                )}
              />
              {!isPopularCategory && (
                <>
                  <TextField
                    type="number"
                    label="Position"
                    variant="outlined"
                    fullWidth
                    {...register("position")}
                    error={errors?.position?.message}
                    helperText={errors?.position?.message}
                  />
                  <label htmlFor="contained-button-file">
                    <input
                      accept="image/*"
                      id="contained-button-file"
                      type="file"
                      onChange={handlefileInput}
                      style={{ display: "none" }}
                    />
                    <Button
                      variant="contained"
                      component="span"
                      // endIcon={<DriveFolderUploadIcon />}
                      color="info"
                    >
                      Upload Image
                    </Button>
                  </label>
                  {imageUploaded && <img src={imageUploaded} width="50px"/>}
                </>
              )}
              <Box>
                <Button disabled={!isPopularCategory && !imageUploaded} variant="contained" color="primary" type="submit">
                  {" "}
                  Create
                </Button>
                <Button
                  sx={{ ml: 2 }}
                  variant="contained"
                  color="error"
                  onClick={handleClose}
                >
                  close
                </Button>
              </Box>
            </Stack>
          </form>
        </Box>
      </Modal>

      {/* snackbar */}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snackbarState}
        autoHideDuration={1000}
        onClose={snackBarClose}
      >
        <Alert
          onClose={snackBarClose}
          severity={status == 200 ? "success" : "error"}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </>
  );
}
